<!-- calendar heading -->
<div class="bg-col-w p-a-2">
    <div class="flex flex-middle flex-justify-between">

        <!-- current month -->
        <div class="flex-grow s2">{{monthDate | date : 'MMMM yyyy'}}</div>

        <!-- prev month -->
        <button class="_monthButton m-r-2"
                type="button"
                (click)="prevMonth()">
            <i class="icon-chevron-left inline-flex"></i>
        </button>
        <!-- next month -->
        <button class="_monthButton"
                type="button"
                (click)="nextMonth()">
            <i class="icon-chevron-right inline-flex"></i>
        </button>
    </div>
    <!-- calendar body -->
    <div class="_body">
        <table>
            <!-- week days names -->
            <tr>
                <th class="col-12 c1"
                    *ngFor="let weekDay of weekDays">
                    <span class="_day">{{weekDay | date:'EEEEE'}}</span>
                </th>
            </tr>

            <!-- weeks -->
            <tr *ngFor="let week of weeks; trackBy indexTrackFn">
                <!-- days -->
                <td *ngFor="let day of week; trackBy indexTrackFn">
                    <span class="col-1 c1"
                          *ngIf="day"
                          class="_day"
                          (click)="pick(day)"
                          [class._picked]="isPicked(day)"
                          [class._disabled]="isDisabled(day)">{{day | date: 'd'}}
                    </span>
                </td>
            </tr>
        </table>
    </div>
</div>
